import { tw } from "@careinfo/tailwind";
import { useFieldArray, useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import Form from "./Form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import journalEntrySchema from "../../validation/JournalEntry";
import PopupModal from "../Reusable/Modal";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import CreateAccountPopup from "../Transaction/CreateAccountPopup";

const CreateCreditNote = (props: any) => {
  const {
    handleCreate,
    isLoading,
    numbSeriesRefetch,
    entryNoRefetch,
    openPrintPopup,
    setOpenPrintPopup,
    isPrintLoading,
    handlePrint,
    handleCreateAccount,
    isPostLoading,
  } = props;

  const navigate = useNavigate();
  const [openAccountPopup, setOpenAccountPopup] = useState(false);

  const {
    handleSubmit,
    setError,
    setValue,
    getValues,
    watch,
    register,
    clearErrors,
    formState: { errors },
    control,
  } = useForm<any>({
    resolver: yupResolver(journalEntrySchema),
    defaultValues: async () => {
      const countData = await entryNoRefetch();
      const numberSeries = await numbSeriesRefetch();
      const today = new Date().toISOString().split("T")[0];
      return {
        number_series: numberSeries?.data?.[0]?.next_series,
        entry_number: `${countData?.data?.count + 1}`,
        voucher_date: today,
        journal_account: [
          {
            account: null,
            credit: 0,
            debit: 0,
          },
          {
            account: null,
            credit: 0,
            debit: 0,
          },
        ],
      };
    },
  });

  const handleClosePrint = () => {
    setOpenPrintPopup(false);
    navigate("/accounting/credit-note");
  };
  const journalAccounts = watch("journal_account");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "journal_account",
  });

  const handleAddRow = () => {
    append({
      account: "",
      debit: 0,
      credit: 0,
    });
  };

  return (
    <div>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleCreate(data, false, setError))}
        >
          <Form
            control={control}
            register={register}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            isEdit={false}
            setOpenAccountPopup={setOpenAccountPopup}
            watch={watch}
            fields={fields}
            handleAddRow={handleAddRow}
            remove={remove}
          />
          <div className={tw`w-full flex gap-x-4 justify-end px-4`}>
            <div className={tw`w-24 `}>
              <Button
                type="button"
                label="Save to Draft"
                isLoading={isLoading}
                onClick={handleSubmit((data) =>
                  handleCreate(data, true, setError)
                )}
              />
            </div>
            <div className={tw`w-24 `}>
              <Button label="Submit" isLoading={isLoading} />
            </div>
          </div>
        </form>
      </Card>

      <PopupModal
        isOpen={openAccountPopup}
        setIsOpen={setOpenAccountPopup}
        title="Create Account"
      >
        <div className={tw`max-w-2xl`}>
          <CreateAccountPopup
            handleCreateAccount={handleCreateAccount}
            isLoading={isPostLoading}
            setOpenAccountPopup={setOpenAccountPopup}
          />
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrint}
        title={"Print"}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print "}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handlePrint}
            autoFocus
          />
          <Button
            type="button"
            label={"Close"}
            onClick={() => handleClosePrint()}
          />
        </form>
      </PopupModal>
    </div>
  );
};

export default CreateCreditNote;
